import { Table } from '@vwfs-bronson/bronson-react';
import { Agent } from '../fes';

export function AgentsTable({ agents }: { agents: Agent[] }) {
  if (agents.length === 0) {
    return <p className="app-empty">No agents found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {agents.map(agent => (
            <Table.Tr key={agent.agentId || agent.name}>
              <Table.Td>{agent.name}</Table.Td>
              <Table.Td>{agent.description || '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
